import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noMatches: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeTypeWithDetails: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeComponentLead: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeProjectDefault: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeProjectLead: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeUnassigned: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeProjectDefaultGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assigneeProjectLeadGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'project-components.component-assignee-placeholder',
		defaultMessage: 'Default assignee',
		description:
			'Default assignee input placeholder in create / edit component. Is shown inside input when no option are selected.',
	},
	noMatches: {
		id: 'project-components.component-assignee-no-matches',
		defaultMessage: 'No Matches',
		description:
			'Default assignee input no result placeholder in create / edit component. Is shown in input dropdown when no search result exist',
	},
	assigneeTypeWithDetails: {
		id: 'project-components.component-assignee-type-with-details',
		defaultMessage: '{assigneeType} ({displayName})',
		description:
			'Default assignee input option label in create / edit component. Is show as option label in select dropdown. {assigneeType} - is translated in separated keys',
	},
	assigneeComponentLead: {
		id: 'project-components.assignee-component-lead',
		defaultMessage: 'Component lead',
		description:
			'Part of default assignee input option label. This translation is used as option for {assigneeType}',
	},
	assigneeProjectDefault: {
		id: 'project-components.assignee-project-default',
		defaultMessage: 'Project default',
		description:
			'Part of assignee input option label. This translation is used as part of option for {assigneeType}',
	},
	assigneeProjectLead: {
		id: 'project-components.assignee-project-lead',
		defaultMessage: 'Project lead',
		description:
			'Part of assignee input option label. This translation is used as part of option for {assigneeType}',
	},
	assigneeUnassigned: {
		id: 'project-components.assignee-unassigned',
		defaultMessage: 'Unassigned',
		description:
			'Part of assignee input option label. This translation is used as part of option for {assigneeType}',
	},
	assigneeProjectDefaultGalaxia: {
		id: 'project-components.assignee-project-default-galaxia',
		defaultMessage: 'Space default',
		description:
			'Part of assignee input option label. This translation is used as part of option for {assigneeType}',
	},
	assigneeProjectLeadGalaxia: {
		id: 'project-components.assignee-project-lead-galaxia',
		defaultMessage: 'Space owner',
		description:
			'Part of assignee input option label. This translation is used as part of option for {assigneeType}',
	},
});
export default messages;
